import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getDestinationOutputs } from "../../../http/api/MasterAPI";

const DestinationOutputSelect = ({ value, error, onChangeValue }) => {
  const [destinationOutputs, setDestinationOutputs] = useState([]);
  
  async function getDestinationOutput() {
    try {
      const response = await getDestinationOutputs();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          destinationOutputCd: element.varCd,
          destinationOutputName: element.varValue1,
        }))
        .filter(
          (x) => x.destinationOutputCd && x.destinationOutputName.trim() !== ""
        );
      setDestinationOutputs(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getDestinationOutput();
  }, []);


  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 250 }}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("destinationOutputCd")}
      >
        {destinationOutputs.map((item) => (
          <MenuItem
            key={"destinationOutputCd" + item.destinationOutputCd}
            value={item.destinationOutputCd}
          >
            {item.destinationOutputName}
          </MenuItem>
        ))}
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",  marginLeft: 0 }}>{error}</FormHelperText>
      )}
    </FormControl>
    
  );
};

export default DestinationOutputSelect;